import React from 'react';

export const defaultDeliveryType = {
  key: 'NORMAL',
  displayName: 'NORMAL',
  val: 'NORMAL'
};

export const deliveryTypeStatusMap = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CONFIRMED: 'CONFIRMED'
};

export const deliveryTypeFilterStatusList = [
  { key: 'ALL', val: '' },
  { key: deliveryTypeStatusMap.PENDING, val: deliveryTypeStatusMap.PENDING },
  { key: deliveryTypeStatusMap.APPROVED, val: deliveryTypeStatusMap.APPROVED },
  { key: deliveryTypeStatusMap.CONFIRMED, val: deliveryTypeStatusMap.CONFIRMED }
];

export const appointmentDeliveryType = {
  key: 'APPOINTMENT',
  val: 'APPOINTMENT',
  displayName: 'APPOINTMENT DELIVERY',
  tagKey: 'APPOINTMENT_DELIVERY',
  tagDisplayName: 'APPOINTMENT DELIVERY',
  potentialTagKey: 'POTENTIAL_APPOINTMENT_DELIVERY',
  potentialTagDisplayName: 'POTENTIAL APPOINTMENT DELIVERY',
  tagLabel: 'AD',
  potentialTagLabel: 'P-AD'
};

export const deliveryClientList = [
  {
    key: 'AMAZON',
    val: 'AMAZON'
  },
  {
    key: 'FLIPKART',
    val: 'FLIPKART'
  },
  { key: 'OTHERS', val: 'OTHERS' }
];

export const mallDeliveryType = {
  key: 'MALL',
  val: 'MALL',
  displayName: 'MALL DELIVERY',
  tagKey: 'MALL_DELIVERY',
  tagDisplayName: 'MALL DELIVERY',
  potentialTagKey: 'POTENTIAL_MALL_DELIVERY',
  potentialTagDisplayName: 'POTENTIAL MALL DELIVERY',
  tagLabel: 'MD',
  potentialTagLabel: 'P-MD'
};

export const canteenDeliveryType = {
  key: 'CANTEEN',
  val: 'CANTEEN',
  displayName: 'CANTEEN DELIVERY',
  tagKey: 'CANTEEN_DELIVERY',
  tagDisplayName: 'CANTEEN DELIVERY',
  potentialTagKey: 'POTENTIAL_CANTEEN_DELIVERY',
  potentialTagDisplayName: 'POTENTIAL CANTEEN DELIVERY',
  tagLabel: 'CD',
  potentialTagLabel: 'P-CD'
};

export const plantDeliveryType = {
  key: 'PLANT',
  val: 'PLANT',
  displayName: 'PLANT DELIVERY',
  tagKey: 'PLANT_DELIVERY',
  tagDisplayName: 'PLANT DELIVERY',
  potentialTagKey: 'POTENTIAL_PLANT_DELIVERY',
  potentialTagDisplayName: 'POTENTIAL PLANT DELIVERY',
  tagLabel: 'CD',
  potentialTagLabel: 'P-PD'
};

export const deliveryTypeList = [
  defaultDeliveryType,
  appointmentDeliveryType,
  mallDeliveryType,
  canteenDeliveryType,
  plantDeliveryType
];

export const deliveryTypeMap = {
  APPOINTMENT: appointmentDeliveryType,
  MALL: mallDeliveryType,
  CANTEEN: canteenDeliveryType
};

export const getSmallDeliveryTypeTag = (status, deliveryType) => {
  const deliveryTypeObject = deliveryTypeMap[deliveryType];
  if (!deliveryTypeObject) {
    return null;
  }
  const deliveryTypeTag =
    status === deliveryTypeStatusMap.PENDING
      ? deliveryTypeObject.potentialTagLabel
      : deliveryTypeObject.tagLabel;
  return (
    <div
      className="cnote-tag small appointment-delivery"
      title={deliveryTypeTag}
    >
      {deliveryTypeTag}
    </div>
  );
};

export const isClientAmazon = deliveryClient =>
  deliveryClient === deliveryClientList[0].key;

export const isAppointmentDelivery = deliveryType =>
  deliveryType === appointmentDeliveryType.key;

export const isValueAddedDelivery = deliveryType =>
  deliveryType && deliveryType !== defaultDeliveryType.key;

export const isStatusPending = status =>
  status && status === deliveryTypeStatusMap.PENDING;
